export type LoginFormData = {
  email: string | null;
  password: string | null;
}

export const defaultLoginFormData = {
  email: null,
  password: null,
}
